<template>
    <div class="switch-wrapper">
        <label class="switch">
            <input
                type="checkbox"
                value="1"
                :name="name"
                :checked="checked"
                @click="onChange">
            <span class="slider round"></span>
        </label>
    </div>
</template>

<script>
    export default {
        props: {
            checked: {
                type: Boolean,
                required: false
            },
            name: {
                type: String,
                required: true
            }
        },
        methods: {
            onChange() {
                this.$emit('change', !this.checked);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/variables";

    .switch-wrapper {
        display: inline-block;
        height: 16px;
        vertical-align: middle;

        & .switch {
            position: relative;
            display: inline-block;
            width: 34px;
            height: 16px;
            margin-bottom: 0 !important;
        }

        /* Hide default HTML checkbox */
        & .switch input {
            display: none;
        }

        /* The slider */
        & .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba($dark-background-color, .4);
            -webkit-transition: .4s;
            transition: .4s;
        }

        & .slider:before {
            position: absolute;
            content: "";
            height: 12px;
            width: 12px;
            left: 3px;
            bottom: 2px;
            background-color: white;
            -webkit-transition: .4s;
            transition: .4s;
        }
    }

    input:checked + .slider {
        background-color: $dark-background-color;
    }

    input:disabled + .slider {
        background-color: rgba($dark-background-color, .5);
    }

    input:focus + .slider {
        box-shadow: 0 0 1px $dark-background-color;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(16px);
        -ms-transform: translateX(16px);
        transform: translateX(16px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
</style>
